import {ActiveDeliveryOptionType} from "../stores/cart/cartSlice.types.ts";

export function isDeliveryPersonal(active: ActiveDeliveryOptionType) {
    return active.personal !== null;
}

export function isDeliveryIndividual(active: ActiveDeliveryOptionType) {
    return active.individual !== null;
}

export function isDeliverySelected(active: ActiveDeliveryOptionType) {
    return active.personal !== null || active.individual !== null || (active.packages !== null || active.pallets !== null);
}